import React from 'react';
import { Link } from 'react-router-dom';

const stats = [
  {
    value: '25,000+',
    label: 'Toneladas de capacidad de producción anual',
    icon: 'ri-building-4-line',
  },
  {
    value: '10,000',
    label: 'm² de planta manufacturera y almacén',
    icon: 'ri-store-3-line',
  },
  {
    value: '100',
    label: '% de tasa de calidad de productos entregados',
    icon: 'ri-shield-check-line',
  },
  {
    value: '40+',
    label: 'Tipos de productos químicos industriales',
    icon: 'ri-flask-line',
  },
];

export default function RixinHero() {
  return (
    <section className="relative pt-28 md:pt-36 pb-16 md:pb-24 bg-background-50 overflow-hidden">
      {/* Background decorative */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://rixingroup.cn/wp-content/uploads/2025/07/4f199da00a564850bc83718cd49975f7_720.jpg"
          alt="Planta química industrial de Rixin Group en China"
          className="w-full h-full object-cover opacity-15 select-none"
          draggable="false"
        />
        {/* Anti-download overlay on background */}
        <div
          className="absolute inset-0 z-10"
          onContextMenu={(e) => e.preventDefault()}
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-100/90 via-background-50/95 to-background-50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 mb-8 text-foreground-500 text-xs">
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">Inicio</Link>
            <i className="ri-arrow-right-s-line text-[10px]" />
            <span className="text-foreground-600">Rixin Group</span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Text */}
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
                <i className="ri-global-line text-sm w-4 h-4 flex items-center justify-center" />
                Nuestro Fabricante en China
              </div>

              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
                Rixin Group
                <span className="block text-primary-500 mt-2 text-2xl md:text-3xl">
                  Shaanxi Rixin Environmental Protection Technology Co., Ltd.
                </span>
              </h1>

              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 text-left sm:text-justify">
                Fundada en <strong className="text-foreground-950">1992</strong> en Xi'an, China, Rixin Group es una empresa tecnológica especializada en el desarrollo y producción de productos químicos para la industria petroquímica. Cuenta con dos modernas plantas de producción y un equipo de más de <strong className="text-foreground-950">200 investigadores</strong>.
              </p>

              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 text-left sm:text-justify">
                <strong className="text-foreground-950">RESINVENCA RESINAS DE VENEZUELA C.A.</strong> es el <span className="text-primary-600 font-semibold">vendedor oficial en Venezuela</span> de los demulsificantes ya terminados de Rixin Group. Importamos directamente desde sus instalaciones en China, garantizando producto formulado, certificado y listo para usar en sus operaciones petroleras.
              </p>

              <div className="flex flex-wrap gap-3 mb-8">
                {[
                  { icon: 'ri-shield-check-line', text: 'ISO 9001 / ISO 14001 / OHSAS 18001' },
                  { icon: 'ri-award-line', text: 'Empresa High-Tech Nacional' },
                  { icon: 'ri-flask-line', text: 'Certificación PetroChina' },
                ].map((badge) => (
                  <span
                    key={badge.text}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 border border-background-200/60 text-foreground-600 text-xs"
                  >
                    <i className={`${badge.icon} w-3 h-3 flex items-center justify-center`} />
                    {badge.text}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contacto"
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
                >
                  Solicitar Cotización
                  <i className="ri-arrow-right-line" />
                </Link>
                <a
                  href="https://rixingroup.cn/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-100 border border-background-200/60 text-foreground-600 font-semibold text-sm hover:bg-background-200 hover:text-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-global-line" />
                  Visitar Web Oficial
                </a>
              </div>
            </div>

            {/* Image */}
            <div className="relative">
              <div className="rounded-lg overflow-hidden border border-background-200/60 aspect-[4/3] relative">
                <img
                  src="https://rixingroup.cn/wp-content/uploads/2025/07/4f199da00a564850bc83718cd49975f7_720.jpg"
                  alt="Vista panorámica de las instalaciones de Rixin Group en China"
                  className="w-full h-full object-cover select-none"
                  draggable="false"
                />
                {/* Anti-download overlay */}
                <div
                  className="absolute inset-0 z-10"
                  onContextMenu={(e) => e.preventDefault()}
                  aria-hidden="true"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-primary-500 text-background-50 rounded-lg px-4 py-3 shadow-lg">
                <div className="font-heading text-xl font-bold">33+</div>
                <div className="text-xs opacity-90">Años de Trayectoria</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 mt-16 md:mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/60 text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className={`${stat.icon} text-lg`} />
                </div>
                <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                  {stat.value}
                </div>
                <p className="text-foreground-500 text-xs leading-relaxed">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}